// extracted by mini-css-extract-plugin
export default {"items":"ExpandableProductAccessories__items___WVXEk"};